<template lang='pug' src='./hero.pug'> </template>

<script>
export default {
  name: 'themeoptions',
  computed: {
    props () {
      return this.$store.state.app['themeoptions']
    }
  },
  data () {
    return {
      swiperOption1: {
        centeredSlides: true,
        loop: true,
        spaceBetween: 30,
        effect: 'slide',
        speed: 1000,
        autoplay: {
          delay: 7000,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: '.swiper-button-next1',
          prevEl: '.swiper-button-prev1'
        },
        pagination: {
          el: '.swiper-pagination'
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// hero.vue?34c1e00d